import { forwardRef, memo, MouseEvent } from "react"
import { Link } from "react-router-dom"

interface TableListRowProps {
    children: React.ReactNode
    isHeader?: boolean
    to?: string
    state?: unknown
    onClick?: () => void
    onMouseDown?: (e: MouseEvent) => void
    className?: string
    style?: React.CSSProperties
    hoverEffect?: boolean
    isDeleted?: boolean
}

const TableListRow = forwardRef<HTMLDivElement, TableListRowProps>(({
    className,
    isHeader,
    children,
    to,
    state,
    onClick,
    style,
    hoverEffect = true,
    isDeleted,
    ...props
}, ref) => {
    const classes =
        `table-row [&>div]:border-t [&>div]:border-gray-200 [&>div]:first:border-t-0 transition-colors ${isDeleted ? "bg-red-100" : ""} ${isHeader
            ? "bg-gray-50 font-semibold text-gray-700 lg:rounded-t-md"
            : hoverEffect ? isDeleted ? `hover:bg-red-200 cursor-pointer` : `hover:bg-gray-100 cursor-pointer` : ""
        }`

    if (to) {
        return (
            <Link to={to} state={state} onClick={onClick} className={`${classes} ${className}`} style={style} {...props}>
                {children}
            </Link>
        )
    }
    return (
        <div
            className={`${classes} ${className}`}
            onClick={onClick}
            ref={ref}
            style={style}
            {...props}
        >
            {children}
        </div>
    )
})

TableListRow.displayName = 'TableListRow'

export default memo(TableListRow)